import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Homepage from '../HomePage'
import Cherdchai from '../Cherdchai'
import DestinationPage from '../DestinationPage'
import DestinationPage2 from '../DestinationPage2';
import DestinationCc from '../../components/DestinationCherdchai';
import AboutPage from '../AboutPage'
import ErrorPage from '../ErrorPage'
import ContactPage from '../ContactPage'
import BookingsPage from '../Bookings'
import Rebook from '../Rebook'
import Refund from '../Refund';
import Print from '../Print';
import TermsPage from '../Terms';
import PrivacyPage from '../Privacy';
import SongkranPage from '../Songkran';
import TravelTips from '../Travel';

const AllRoute = () => {
  // Function to force reload for home route
  const HomeRoute = () => {
    window.location.href = '/home';
    return null;
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route exact path='/' element={<Navigate to="/home" replace />} />
          <Route path='home' element={<Homepage />} />
          {/* Force reload when navigating to home from other pages */}
          <Route path='home/reload' element={<HomeRoute />} />
          <Route path='destination' element={<DestinationPage />} />
          <Route path='destination2' element={<DestinationPage2 />} />
          <Route path='about' element={<AboutPage />} />
          <Route path='404' element={<ErrorPage />} />
          <Route path='contact' element={<ContactPage />} />
          <Route path='bookings' element={<BookingsPage />} />
          <Route path='cherdchai' element={<Cherdchai />} />
          <Route path='cherdchai-destinations' element={<DestinationCc />} />
          <Route path='rebook' element={<Rebook />} />
          <Route path='refund' element={<Refund />} />
          <Route path='print' element={<Print />} />
          <Route path='terms' element={<TermsPage />} />
          <Route path='privacy' element={<PrivacyPage />} />
          <Route path='songkran' element={<SongkranPage />} />
          <Route path='travel-tips' element={<TravelTips />} />
          {/* Catch-All Route for 404 */}
          <Route path='*' element={<ErrorPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default AllRoute;
